import PubSub from "pubsub-js";

function throttle(fn: (...args: any[]) => void, delay: number) {
  let lastCall = 0;
  return function (...args: any[]) {
    const now = Date.now();
    if (now - lastCall >= delay) {
      lastCall = now;
      fn.apply(this, args);
    }
  };
}

let pageActive = true;
let userInactiveTimer;
let pageInactiveHandler;
const userInactiveTimeout = 60 * 5 * 1000;

function handleUserActivity() {
  if (!pageActive && !document.hidden) {
    pageActive = true;
    console.log("user active");
    PubSub.publish("onUserActive");
  }
  throttle(resetUserInactiveTimer, 500)();
}

function resetUserInactiveTimer() {
  clearTimeout(userInactiveTimer);
  userInactiveTimer = setTimeout(() => {
    if (!document.hidden) {
      // trigger only if the page is visible
      pageActive = false;
      console.log("user inactive");
      PubSub.publish("onUserInactive");
    }
  }, userInactiveTimeout);
}

function handlePageActive() {
  if (document.hidden) {
    // clear user inactive timer when page is hidden
    clearTimeout(userInactiveTimer);
    console.log("page switched out");
    if (!pageInactiveHandler) {
      pageInactiveHandler = setTimeout(() => {
        console.log("page inactive");
        pageActive = false;
        PubSub.publish("onPageInactive");
      }, userInactiveTimeout);
    }
  } else {
    handleUserActivity();
    console.log("page switched in");
    clearTimeout(pageInactiveHandler);
    pageInactiveHandler = null;
    if (!pageActive) {
      console.log("page active");
      pageActive = true;
      PubSub.publish("onPageActive");
    }
  }
}
document.addEventListener("mousemove", handleUserActivity);
document.addEventListener("keydown", handleUserActivity);
document.addEventListener("scroll", handleUserActivity);
document.addEventListener("mousedown", handleUserActivity);
document.addEventListener("visibilitychange", handlePageActive, false);
// 初始化定时器
resetUserInactiveTimer();
